// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3iaHx","section":"styles__section___2aGNx"};